// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

// 🆕 ErrorBoundary (Phase 1)
import ErrorBoundary from './components/ErrorBoundary';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </ErrorBoundary>
    </React.StrictMode>
);

// 🆕 Phase 2 : enregistrer le SW avec callbacks
serviceWorkerRegistration.register({
    onSuccess: (registration) => {
        console.log('📦 App prête pour un usage hors-ligne.');
    },
    onUpdate: (registration) => {
        console.log('🔄 Mise à jour détectée — rechargement imminent.');
    },
});

reportWebVitals();